import { useNavigate } from 'react-router-dom';
import { Button } from '../components/common/Button';
import { GlassPanel } from '../components/common/GlassPanel';
import { Logo } from '../components/common/Logo';
import { AuthBackdrop } from '../components/auth/AuthBackdrop';

/**
 * Not found page for unknown routes.
 */
export default function NotFoundPage() {
  const navigate = useNavigate();

  /**
   * Returns the user to the home page.
   */
  const handleGoHome = () => {
    navigate('/');
  };

  /**
   * Returns the user to the login page.
   */
  const handleGoLogin = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 page-shell">
      <AuthBackdrop />
      <GlassPanel variant="strong" className="text-center max-w-md w-full space-y-6 relative z-10">
        <div className="flex justify-center">
          <Logo size="sm" />
        </div>
        <div className="space-y-2">
          <p className="text-sm uppercase tracking-[0.3em] text-ink-400">404</p>
          <h1 className="text-3xl font-semibold">Room Not Found</h1>
          <p className="text-ink-200">
            The page you requested does not exist or the link has expired.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={handleGoHome}>Go to Home</Button>
          <Button variant="secondary" onClick={handleGoLogin}>
            Go to Login
          </Button>
        </div>
      </GlassPanel>
    </div>
  );
}
